export default "__VITE_ASSET__6uyM9VuX__"